// 9fbef606107a605d69c0edbcd8029e5d
import {
  FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST,
  FETCH_SHOP_BY_LOOK_STYLITICS_SUCCESS,
  FETCH_SHOP_BY_LOOK_STYLITICS_FAILURE,
} from './ShopByLookStylitics.constants';

export const fetchShopByLookStyliticsRequest = (tagName, count, uniqueKey, isRedirectToPDP) => ({
  type: FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST,
  payload: { tagName, count, uniqueKey, isRedirectToPDP },
});

export const fetchShopByLookStyliticsSuccess = (uniqueKey, data) => ({
  type: FETCH_SHOP_BY_LOOK_STYLITICS_SUCCESS,
  payload: { uniqueKey, data },
});

export const fetchShopByLookStyliticsFailure = (uniqueKey, error) => ({
  type: FETCH_SHOP_BY_LOOK_STYLITICS_FAILURE,
  payload: { uniqueKey, error },
});
